import React from 'react';
import { Form, Card, Select, Button, Spin, message } from 'antd';
import { connect } from 'dva';
import { routerRedux } from 'dva/router';
import { formItemLayout } from 'utils/utils.js';
import { debounce } from 'lodash-decorators';
import styles from './Index.less';

const FormItem = Form.Item;
const { Option } = Select;

@connect(({ operationChargeItemPublishChargeItemSteps, loading }) => ({
  loadingFetchPublishSchoolDataSource:
    loading.effects['operationChargeItemPublishChargeItemSteps/fetchPublishSchoolDataSource'],
  publishSchoolsDataSource: operationChargeItemPublishChargeItemSteps.publishSchoolsDataSource,
  publishSchool: operationChargeItemPublishChargeItemSteps.publishSchool,
}))
@Form.create()
export default class Step2 extends React.Component {
  constructor(props) {
    super(props);

    this.handleSearchPublishSchoolsDataSource = this.handleSearchPublishSchoolsDataSource.bind(
      this
    );
    this.handlePrevStep = this.handlePrevStep.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  @debounce(1000)
  handleSearchPublishSchoolsDataSource(param) {
    if (!param) {
      return;
    }

    const { dispatch } = this.props;

    dispatch({
      type: 'operationChargeItemPublishChargeItemSteps/savePublishSchoolsDataSource',
      publishSchoolsDataSource: [],
    });

    dispatch({
      type: 'operationChargeItemPublishChargeItemSteps/fetchPublishSchoolDataSource',
      param,
    }).then(length => {
      if (length === 0) {
        message.warn('未匹配到此学校');
      }
    });
  }

  handlePrevStep() {
    this.props.dispatch(routerRedux.goBack());
  }

  handleSubmit(e) {
    e.preventDefault();

    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.dispatch({
          type: 'operationChargeItemPublishChargeItemSteps/savePublishSchool',
          ...values,
        });

        this.props.dispatch({
          type: 'operationChargeItemPublishChargeItemSteps/incrementCurrentStep',
        });
      }
    });
  }

  render() {
    const {
      loadingFetchPublishSchoolDataSource,
      publishSchoolsDataSource,
      form,
      publishSchool,
    } = this.props;
    const { getFieldDecorator } = form;

    return (
      <Card bordered={false} className={styles.root}>
        <Form onSubmit={this.handleSubmit} className={styles.root}>
          <FormItem {...formItemLayout} label="学校名称/School ID">
            {getFieldDecorator('publishSchool', {
              initialValue: publishSchool || undefined,
              rules: [{ required: true, message: '请选择学校' }],
            })(
              <Select
                allowClear
                labelInValue
                showSearch
                placeholder="请选择"
                notFoundContent={
                  loadingFetchPublishSchoolDataSource ? (
                    <Spin size="small" />
                  ) : (
                    '请输入关键字进行搜索'
                  )
                }
                filterOption={false}
                onSearch={this.handleSearchPublishSchoolsDataSource}
              >
                {publishSchoolsDataSource.map(school => (
                  <Option key={school.orgId}>{school.orgName}</Option>
                ))}
              </Select>
            )}
          </FormItem>

          <FormItem className="operation-button-wrap">
            <Button onClick={this.handlePrevStep}>返回</Button>
            <Button type="primary" htmlType="submit">
              下一步
            </Button>
          </FormItem>
        </Form>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Operation/ChargeItem/PublishChargeItemSteps/StepSelectSchool/Index.js